// extracted by mini-css-extract-plugin
module.exports = {"Center":"Center_Center__PAIKh"};